import { render } from "./HeroiconsSolidPencilAlt.vue?vue&type=template&id=78f93406"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPencilAlt.vue"]])

export default __exports__